<template>
  <div class="card" id="post-category-multi-select">
    <div class="card-body">
      <div class="divide-y">
        <div class="row">
          <template v-if="isShow()">
            <h3 class="card-title title">Категории</h3>
            <span class="col-12">
              <CategoryTree v-model="treeSelection" :nodes="treeList" />
            </span>
          </template>
          <template v-else>
            <div class="mb-3">
              <div class="loader-item">
                <div class="spinner-border spinner-border-sm me-2"></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import CategoryTree from "@/components/category_tree/Index"
import Api from "./services/Api"

export default defineComponent({
  name: "CategoryMulti",
  emits: ['onChange'],
  components: {
    CategoryTree,
  },
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let treeSelection = ref([])
    let treeList = ref([])
    let show = ref(false)

    const fields = reactive({
      val: [],
    })

    onMounted(async () => {
      updateFields(props.payload)

      markUnshow()
      await fillCategories()
      markShow()
    })

    function fillCategories() {
      return Api.categories().then((resp) => {
        buildTree(resp.data["items"])
      })
    }

    function updateFields(query) {
      fields.val = query.val
      treeSelection.value = query.val
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function buildTree(response) {
      let el = []

      response.forEach((o) => {
        o["label"] = o["category_name"]
        o["id"] = o["category_id"]
        o["category_str_path"] = o["category_str_path"].replaceAll("###", "/")

        o["children"] = o["children"] || []

        Object.assign(el[o["category_id"]] = el[o["category_id"]] || {}, o)

        el[o["category_parent_id"]] = el[o["category_parent_id"]] || {}
        el[o["category_parent_id"]].children = el[o["category_parent_id"]].children || []
        el[o["category_parent_id"]].children.push(el[o["category_id"]])
      });

      if (el.length) {
        el.length = 1
        treeList.value = buildList(el[0].children)
      }
    }

    function buildList(list) {
      if (list.length) {
        return list.map(item => {
          let newItem = {}

          for (let key in item) {
            if (key === 'children') {
              newItem[key] = buildList(item[key])
            } else {
              newItem[key] = item[key]
            }
          }

          return newItem
        })
      }

      return []
    }

    watch(treeSelection, (val) => {
      emit("onChange", val)
    })

    return {
      isShow,
      treeSelection,
      treeList,
    }
  }
})
</script>

<style scoped src="./css/style.css" />
